import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'

const AgendaCRUD = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const exclui = useCallback((dados) => {
    metodoPrograma('exclui', { idAgenda: dados[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(undefined)
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  const renderColor = (color) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <div
        style={{
          width: 20,
          height: 20,
          backgroundColor: color,
          border: '1px solid #ccc',
          borderRadius: 4,
        }}
      />
      <span>{color}</span>
    </div>
  )

  return (
    <Programa codigo="CtrlAgenda" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {localAtendimento !== undefined && localAtendimento !== null && (
              <PrimeTable
                codigo="CtrlAgenda"
                action="lista"
                rows={10}
                habSearch
                head={[
                  'Profissional',
                  'Nome Agenda',
                  'Tempo',
                  'Programação Enfermagem',
                  'Fundo',
                  'Texto',
                  'Data Exclusão',
                ]}
                parametros={{ idLocalAtendimento: localAtendimento[0] }}
                line={(item) => [
                  item[2],
                  item[3],
                  item[4],
                  item[11] === 'S' ? 'Sim' : 'Não',
                  renderColor(item[12]),
                  renderColor(item[13]),
                  item[5],
                ]}
                collumnsDateHour={[3]}
                onRowSelect={handleClick}
                onDelete={{ index: 5, action: exclui }}
                refresh={refresh}
              />
            )}
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar }} />
      )}
    </Programa>
  )
}

export default AgendaCRUD
